import { Card, CardRootProps, TextProps } from '@chakra-ui/react';
import { MouseEvent, ReactNode } from 'react';
import { MFlex, MHeading, MText } from './..';

const disabledStyle = {
  color: 'tPurple.lightGrayPurple',
};

export interface ButtonCardProps extends Omit<CardRootProps, 'title'> {
  titleLeftContent?: ReactNode;
  title: ReactNode;
  titleProps?: TextProps;
  titleRightContent?: ReactNode;
  descriptionProps?: TextProps;
  description: ReactNode;
  isDisabled?: boolean;
  comingSoon?: boolean;
  onClick?: (event?: MouseEvent<HTMLDivElement>) => void;
}

export const ButtonCard = ({
  title,
  titleProps,
  titleLeftContent,
  titleRightContent,
  description,
  descriptionProps,
  isDisabled,
  onClick,
  ...rest
}: ButtonCardProps) => {
  return (
    <Card.Root
      variant="border"
      w="310px"
      role="group"
      className="group"
      onClick={onClick}
      _hover={
        !isDisabled
          ? {
              bg: 'bg.hover',
              boxShadow: 'sm',
              cursor: 'pointer',
            }
          : {}
      }
      {...rest}
    >
      <Card.Body>
        <MFlex alignItems="center" justifyContent="space-between">
          <MFlex columnGap={1.5} alignItems="center">
            {titleLeftContent}
            <MHeading
              fontWeight="medium"
              size="sm"
              as="h5"
              color={isDisabled ? disabledStyle.color : 'tPurple.dark'}
              {...titleProps}
            >
              {title}
            </MHeading>
          </MFlex>
          {titleRightContent}
        </MFlex>

        <MText
          color={isDisabled ? disabledStyle.color : 'tGray.darkPurple'}
          _groupHover={!isDisabled ? { color: 'tPurple.dark' } : {}}
          mt={2}
          lineHeight="18px"
          {...descriptionProps}
        >
          {description}
        </MText>
      </Card.Body>
    </Card.Root>
  );
};
